import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import 'presentation/style/index.scss';
import UserContMain from 'presentation/view/container/User/UserContMain';

CommonEntrypoint(<UserContMain/>)